import VeeValidate from 'vee-validate';
import { messages } from './messages';
import { custom } from './custom';
export function setLocale(locale: string = 'en') {
  VeeValidate.Validator.localize(locale, {
    messages,
    custom,
  });
}
